enum ErrorType {
	Network = "Network",
	Default = "Default",
	Git = "Git",
	Silent = "Silent",
	Parse = "Parse",
	NetworkApi = "NetworkApi",
	TokenValidation = "TokenValidation",
	CliUser = "CliUser",
}

export default ErrorType;
